import { createReducer, on } from '@ngrx/store';
import { IAuthUser } from '@core/interfaces/user';
import { EStateStatus } from '@app/app.state';
import { AuthActions } from './auth.actions';

export interface IAuthState {
  currentUser: IAuthUser | null;
  error: string | null;
  status: EStateStatus;
  init: boolean;
  favoriteUrl: string | null;
}
export const initialState: IAuthState = {
  currentUser: null,
  error: null,
  status: EStateStatus.PENDING,
  init: false,
  favoriteUrl: null,
};
export const authReducer = createReducer(
  initialState,
  on(AuthActions.initialized, (state, { user, error }) => ({
    ...state,
    currentUser: user,
    error,
    init: true,
    status: error ? EStateStatus.ERROR : EStateStatus.SUCCESS,
  })),
  on(AuthActions.profileLoaded, (state, { user }) => ({
    ...state,
    currentUser: user,
  })),
  on(AuthActions.sessionEnded, (state) => ({ ...state, currentUser: null })),
  on(AuthActions.setFavoriteUrl, (state, { favoriteUrl }) => ({
    ...state,
    favoriteUrl,
  })),
);
